/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityPrevalenceRequest {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityPrevalenceRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityPrevalenceRequest>): AppSecopsVulnerabilityPrevalenceRequest {
        let obj = Object.assign(new AppSecopsVulnerabilityPrevalenceRequest(), model);
        AppSecopsVulnerabilityPrevalenceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityPrevalenceRequest>): AppSecopsVulnerabilityPrevalenceRequest {
        if (!model) return null;
        return AppSecopsVulnerabilityPrevalenceRequest.newInstance(<AppSecopsVulnerabilityPrevalenceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityPrevalenceRequest) {
        if (!obj) return;

        models.AppSecopsVulnerabilityPrevalenceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityPrevalenceRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityPrevalenceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of tenant IDs
     */
    tenant_ids: Array<string>;

    /**
     * List of vulnerability IDs to fetch organization-wide prevalence data
     */
    vulnerability_ids: Array<string>;

}
